import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=2f0d428e&scoped=true&"
import script from "./InvoiceTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=2f0d428e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0d428e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0d428e')) {
      api.createRecord('2f0d428e', component.options)
    } else {
      api.reload('2f0d428e', component.options)
    }
    module.hot.accept("./InvoiceTable.vue?vue&type=template&id=2f0d428e&scoped=true&", function () {
      api.rerender('2f0d428e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/InvoiceTable.vue"
export default component.exports